import Vue from 'vue'
import { addGA } from '@/utils/assist'
export default new Vue({
  data() {
    return {
      is_ind: 0,
      isRender: false,
      langIndex: 0,
      langs: [
        {
          name: 'English',
          abbr: 'EN',
          tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
          pp: 'https://contentgarena-a.akamaihd.net/legal/pp/pp_en.html',
          transify: {
            "TOAST_ERROR_CODE": "Unknown error, error code {code}",
            "TOAST_EVENT_CLOSED_AWHILE": "The event is closed temporary",
            "TOAST_EVENT_END": "Event ended",
            "TOAST_EVENT_NOTOPEN": "Event hasn't started",
            "TOAST_GEM_NOT_ENOUGH": "Insufficient diamonds, please top up and come back again",
            "TOAST_LOGIN_FAILED": "Login failed",
            "TOAST_NETWORK_BUSY": "Server busy, please try again later",
            "TOAST_NETWORK_ERROR": "Network connection error, please try again later",
            "TOAST_OPERATE_BUSY": "Too many requests, please try again later",
            "TOAST_PAY_FAILED": "Purchase failed",
            "TOAST_SERVER_BUSY": "Server busy, please try again later",
            "TOAST_SERVER_NOTWORK": "Service unavailable",
            "TOAST_SERVER_TIMEOUT": "Service timeout",
            "TOAST_WRONG_REGION": "This event is not available for your region"
          }
        },
        {
          name: 'Português',
          abbr: 'PT',
          tos: 'http://content.garena.com/legal/tos/tos_pt.html',
          pp: 'http://content.garena.com/legal/pp/pp_pt.html',
          transify: {
            "TOAST_ERROR_CODE": "erro desconhecido, código desconhecido {code}",
            "TOAST_EVENT_CLOSED_AWHILE": "O evento está temporariamente fechado.",
            "TOAST_EVENT_END": "Evento finalizado",
            "TOAST_EVENT_NOTOPEN": "o evento não começou",
            "TOAST_GEM_NOT_ENOUGH": "Diamantes insuficientes. Realize uma recarga para continuar.",
            "TOAST_LOGIN_FAILED": "falha de login",
            "TOAST_NETWORK_BUSY": "O servidor está ocupado. Tente novamente mais tarde.",
            "TOAST_NETWORK_ERROR": "Erro de conexão, tente novamente mais tarde.",
            "TOAST_OPERATE_BUSY": "A operação é muito frequente. Tente novamente mais tarde.",
            "TOAST_PAY_FAILED": "falha aos comprar",
            "TOAST_SERVER_BUSY": "Servidor ocupado, tente novamente mais tarde.",
            "TOAST_SERVER_NOTWORK": "serviço indisponível",
            "TOAST_SERVER_TIMEOUT": "tempo excedido",
            "TOAST_WRONG_REGION": "Evento indisponível"
          }
        },
        {
          name: 'Español',
          abbr: 'ES',
          tos: 'http://content.garena.com/legal/tos/tos_es.html',
          pp: 'http://content.garena.com/legal/pp/pp_es.html',
          transify: {
            "TOAST_ERROR_CODE": "Error desconocido, código de error {code}",
            "TOAST_EVENT_CLOSED_AWHILE": "Evento cerrado temporalmente",
            "TOAST_EVENT_END": "El evento ha terminado",
            "TOAST_EVENT_NOTOPEN": "El evento aún no ha comenzado",
            "TOAST_GEM_NOT_ENOUGH": "Tus diamantes no son suficientes, por favor haz una recarga",
            "TOAST_LOGIN_FAILED": "Error en iniciar sesión",
            "TOAST_NETWORK_BUSY": "Servidor ocupado, por favor intenta de nuevo más tarde",
            "TOAST_NETWORK_ERROR": "Error de conexión, intenta de nuevo más tarde",
            "TOAST_OPERATE_BUSY": "La operación falló, por favor intenta de nuevo más tarde.",
            "TOAST_PAY_FAILED": "La compra falló",
            "TOAST_SERVER_BUSY": "Server busy, please try again later",
            "TOAST_SERVER_NOTWORK": "Servicio no disponible",
            "TOAST_SERVER_TIMEOUT": "El tiempo de espera ha excedido, por favor inténtalo más tarde",
            "TOAST_WRONG_REGION": "This event is not available for your region"
          }
        },
        {
          name: 'Indonesian',
          abbr: 'ID',
          tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_id.html',
          pp: 'https://contentgarena-a.akamaihd.net/legal/pp/pp_id.html',
          transify: {
            "TOAST_ERROR_CODE": "Error, kode error {code}",
            "TOAST_EVENT_CLOSED_AWHILE": "Event ditutup sementara",
            "TOAST_EVENT_END": "Event sudah berakhir",
            "TOAST_EVENT_NOTOPEN": "Event belum dimulai",
            "TOAST_GEM_NOT_ENOUGH": "diamond tidak cukup, silahkan lakukan top up terlebih dahulu",
            "TOAST_LOGIN_FAILED": "login gagal",
            "TOAST_NETWORK_BUSY": "Server sibuk, silahkan coba kembali dalam beberapa saat.",
            "TOAST_NETWORK_ERROR": "Koneksi kamu bermasalah, silahkan coba kembali dalam beberapa saat",
            "TOAST_OPERATE_BUSY": "Terlalu banyak klik, silahkan coba kembali",
            "TOAST_PAY_FAILED": "Pembelian gagal",
            "TOAST_SERVER_BUSY": "Server busy, please try again later",
            "TOAST_SERVER_NOTWORK": "Tidak ada koneksi",
            "TOAST_SERVER_TIMEOUT": "Koneksi timeout",
            "TOAST_WRONG_REGION": "This event is not available for your region"
          }
        },
        {
          name: 'ภาษาไทย',
          abbr: 'TH',
          tos: 'http://content.garena.com/legal/tos/tos_th.html',
          pp: 'http://content.garena.com/legal/pp/pp_th.html',
          transify: {
            "TOAST_ERROR_CODE": "ผิดพลาด {code}",
            "TOAST_EVENT_CLOSED_AWHILE": "ปิดกิจกรรมชั่วคราว",
            "TOAST_EVENT_END": "กิจกรรมจบแล้ว",
            "TOAST_EVENT_NOTOPEN": "กิจกรรมยังไม่เริ่ม",
            "TOAST_GEM_NOT_ENOUGH": "เพชรเกือบจะพอ",
            "TOAST_LOGIN_FAILED": "ล็อกอินไม่สำเร็จ",
            "TOAST_NETWORK_BUSY": "รอ 5 นาทีค่อยเข้าใหม่",
            "TOAST_NETWORK_ERROR": "การเชื่อมต่อผิดพลาด",
            "TOAST_OPERATE_BUSY": "กดถี่ไป ใจเย็นๆ",
            "TOAST_PAY_FAILED": "ซื้อไม่สำเร็จ",
            "TOAST_SERVER_BUSY": "รอซัก 5 นาที ค่อยกดใหม่",
            "TOAST_SERVER_NOTWORK": "ระบบล่ม",
            "TOAST_SERVER_TIMEOUT": "ระบบหมดเวลา",
            "TOAST_WRONG_REGION": "กรุณาย้ายภูมิภาค"
          }
        },
        {
          name: 'Русский',
          abbr: 'RU',
          tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
          pp: 'https://contentgarena-a.akamaihd.net/legal/pp/pp_en.html',
          transify: {
            "TOAST_ERROR_CODE": "Неизвестная ошибка {code}",
            "TOAST_EVENT_CLOSED_AWHILE": "Событие временно закрыто",
            "TOAST_EVENT_END": "Событие завершено",
            "TOAST_EVENT_NOTOPEN": "Событие еще не началось",
            "TOAST_GEM_NOT_ENOUGH": "Недостаточно алмазов, пополните и возвращайтесь",
            "TOAST_LOGIN_FAILED": "Ошибка входа",
            "TOAST_NETWORK_BUSY": "Сервер перегружен, зайдите через 5 минут",
            "TOAST_NETWORK_ERROR": "Ошибка соединения, попробуйте еще",
            "TOAST_OPERATE_BUSY": "Слышком много запросов, попробуйте позже",
            "TOAST_PAY_FAILED": "Покупка не удалась",
            "TOAST_SERVER_BUSY": "Сервер перегружен, зайдите через 5 минут",
            "TOAST_SERVER_NOTWORK": "Сервис недоступен",
            "TOAST_SERVER_TIMEOUT": "Время запроса истекло",
            "TOAST_WRONG_REGION": "Событие не доступно на вашем регионе"
          }
        },
        // {
        //   name: '한국어',
        //   abbr: 'KO',
        //   tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
        //   pp: 'http://ff.garena.com/others/policy/kr/',
        //   transify: {
        //     "TOAST_ERROR_CODE": "알 수 없는 오류, 오류 코드 {code}",
        //     "TOAST_EVENT_CLOSED_AWHILE": "이벤트가 일시적으로 종료되었습니다",
        //     "TOAST_EVENT_END": "이벤트 종료",
        //     "TOAST_EVENT_NOTOPEN": "이벤트가 아직 시작되지 않았습니다",
        //     "TOAST_GEM_NOT_ENOUGH": "다이아몬드가 부족합니다. 충전하고 다시 오세요",
        //     "TOAST_LOGIN_FAILED": "로그인 실패",
        //     "TOAST_NETWORK_BUSY": "서버 사용량이 많습니다. 나중에 다시 시도해주세요",
        //     "TOAST_NETWORK_ERROR": "네트워크 연결 오류입니다. 나중에 다시 시도해주세요",
        //     "TOAST_OPERATE_BUSY": "요청이 너무 많습니다. 나중에 다시 시도해주세요",
        //     "TOAST_PAY_FAILED": "구매 실패",
        //     "TOAST_SERVER_BUSY": "서버 사용량이 많습니다. 나중에 다시 시도해주세요",
        //     "TOAST_SERVER_NOTWORK": "이용할 수 없는 서비스",
        //     "TOAST_SERVER_TIMEOUT": "서비스 시간 초과",
        //     "TOAST_WRONG_REGION": "소속된 구역에 진행 불가능합니다"
        //   }
        // },
        {
          name: 'العربية',
          abbr: 'AR',
          tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
          pp: 'https://contentgarena-a.akamaihd.net/legal/pp/pp_en.html',
          transify: {
            "TOAST_ERROR_CODE": "خطأ غير معروف ، كود الخطأ {code}",
            "TOAST_EVENT_CLOSED_AWHILE": "أغُلق الحدث بشكل مؤقت",
            "TOAST_EVENT_END": "انتهى الحدث",
            "TOAST_EVENT_NOTOPEN": "خارج مدة الحدث",
            "TOAST_GEM_NOT_ENOUGH": "جواهرك غير كافية ، الرجاء الذهاب الى  الشحن",
            "TOAST_LOGIN_FAILED": "فشل الدخول",
            "TOAST_NETWORK_BUSY": "السيرفر مشغول ، الرجاء إعادة المحاولة مرة اخرى",
            "TOAST_NETWORK_ERROR": "خطأ في الاتصال بالشبكة، يرجى إعادة المحاولة مرة أخرى",
            "TOAST_OPERATE_BUSY": "تكرار العملية عدة مرات ، الرجاء إعادة المحاولة مرى أخرى",
            "TOAST_PAY_FAILED": "فشل عمليةالدفع",
            "TOAST_SERVER_BUSY": "Server busy, please try again later",
            "TOAST_SERVER_NOTWORK": "الخدمة غير متوفرة",
            "TOAST_SERVER_TIMEOUT": "نفذت مدة الخدمة",
            "TOAST_WRONG_REGION": "هذا الحدث غير متوفر في منطقتك"
          }
        },
        {
          name: 'Tiếng Việt',
          abbr: 'VI',
          tos: 'https://www.garena.vn/terms',
          pp: 'https://www.garena.vn/privacy',
          transify: {
            "TOAST_ERROR_CODE": "Có lỗi. Lỗi {code}",
            "TOAST_EVENT_CLOSED_AWHILE": "Bảo trì tạm thời sự kiện",
            "TOAST_EVENT_END": "Sự kiện đã kết thúc",
            "TOAST_EVENT_NOTOPEN": "Sự kiện chưa bắt đầu",
            "TOAST_GEM_NOT_ENOUGH": "Không đủ Kim Cương. Vui lòng nạp và quay lại sau",
            "TOAST_LOGIN_FAILED": "Đăng nhập thất bại",
            "TOAST_NETWORK_BUSY": "Hệ thống quá tải. Vui lòng thử lại sau.",
            "TOAST_NETWORK_ERROR": "Lỗi kết nối mạng, vui lòng thử lại sau",
            "TOAST_OPERATE_BUSY": "Hệ thống quá tải. Vui lòng thử lại sau",
            "TOAST_PAY_FAILED": "Giao dịch thất bại",
            "TOAST_SERVER_BUSY": "Server busy, please try again later",
            "TOAST_SERVER_NOTWORK": "Dịch vụ không có sẵn",
            "TOAST_SERVER_TIMEOUT": "Service timeout",
            "TOAST_WRONG_REGION": "This event is not available for your region"
          }
        },
        {
          name: '中文(繁體)',
          abbr: 'TW',
          tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_zh-TW.html',
          pp: 'https://contentgarena-a.akamaihd.net/legal/pp/pp_zh-TW.html',
          transify: {
            "TOAST_ERROR_CODE": "發現未知問題，錯誤代碼{code}",
            "TOAST_EVENT_CLOSED_AWHILE": "活動暫時關閉",
            "TOAST_EVENT_END": "活動已結束",
            "TOAST_EVENT_NOTOPEN": "活動未開始",
            "TOAST_GEM_NOT_ENOUGH": "你的鑽石不足，請前往充值",
            "TOAST_LOGIN_FAILED": "登入失敗",
            "TOAST_NETWORK_BUSY": "伺服器忙碌中，請稍後再試",
            "TOAST_NETWORK_ERROR": "網路連接錯誤，請稍後再試",
            "TOAST_OPERATE_BUSY": "操作過於頻繁，請稍後再試",
            "TOAST_PAY_FAILED": "支付失敗",
            "TOAST_SERVER_BUSY": "伺服器忙碌中，請稍後再試試看",
            "TOAST_SERVER_NOTWORK": "服務不可用",
            "TOAST_SERVER_TIMEOUT": "伺服器請求超時",
            "TOAST_WRONG_REGION": "此活動沒有在你的地區開放"
          }
        },
        // {
        //   name: '日本語',
        //   abbr: 'JA',
        //   tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
        //   pp: 'http://ff.garena.com/others/policy/en/',
        //   transify: {
        //     "TOAST_ERROR_CODE": "未知の問題は発生、エラーコード{code}",
        //     "TOAST_EVENT_CLOSED_AWHILE": "しばらくこのイベントは停止します",
        //     "TOAST_EVENT_END": "当イベントは終わりました",
        //     "TOAST_EVENT_NOTOPEN": "当イベントは未開放です",
        //     "TOAST_GEM_NOT_ENOUGH": "ダイヤが足りませんので、チャージしてください",
        //     "TOAST_LOGIN_FAILED": "ログイン失敗",
        //     "TOAST_NETWORK_BUSY": "サーバーは混雑していますので、しばらく経ってからもう一度試してください",
        //     "TOAST_NETWORK_ERROR": "ネットワークは混雑していますので、しばらく経ってからもう一度試してください",
        //     "TOAST_OPERATE_BUSY": "操作がおおすぎますので、しばらく経ってからもう一度試してください",
        //     "TOAST_PAY_FAILED": "支払いは失敗しました",
        //     "TOAST_SERVER_BUSY": "Server busy, please try again later",
        //     "TOAST_SERVER_NOTWORK": "service unavailable",
        //     "TOAST_SERVER_TIMEOUT": "service timeout",
        //     "TOAST_WRONG_REGION": "This event is not available for your region"
        //   }
        // },
        {
          name: 'Türk',
          abbr: 'TR',
          tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
          pp: 'http://ff.garena.com/others/policy/en/',
          transify: {
            "TOAST_ERROR_CODE": "Bilinmeyen hata, hata kodu {code}",
            "TOAST_EVENT_CLOSED_AWHILE": "Etkinlik geçici olarak devre dışı",
            "TOAST_EVENT_END": "Etkinlik sona erdi",
            "TOAST_EVENT_NOTOPEN": "Etkinlik başlamadı",
            "TOAST_GEM_NOT_ENOUGH": "Yetersiz elmas, lütfen yükleme yap ve tekrar dene.",
            "TOAST_LOGIN_FAILED": "Giriş başarısız",
            "TOAST_NETWORK_BUSY": "Sunucu meşgul, lütfen daha sonra tekrar dene",
            "TOAST_NETWORK_ERROR": "Ağ bağlantısı hatası, lütfen sonra tekrar dene",
            "TOAST_OPERATE_BUSY": "Çok fazla istek var, lütfen daha sonra tekrar dene",
            "TOAST_PAY_FAILED": "Satın alım başarısız",
            "TOAST_SERVER_BUSY": "Server busy, please try again later",
            "TOAST_SERVER_NOTWORK": "Servis meşgul",
            "TOAST_SERVER_TIMEOUT": "Servis Zaman Aşımı",
            "TOAST_WRONG_REGION": "This event is not available for your region"
          }
        },
        {
          name: 'Français',
          abbr: 'FR',
          tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
          pp: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
          transify: {
            "TOAST_ERROR_CODE": "Unknown error, error code {code}",
            "TOAST_EVENT_CLOSED_AWHILE": "The event is closed temporary",
            "TOAST_EVENT_END": "Event ended",
            "TOAST_EVENT_NOTOPEN": "Event hasn't started",
            "TOAST_GEM_NOT_ENOUGH": "Insufficient diamonds, please top up and come back again",
            "TOAST_LOGIN_FAILED": "Login failed",
            "TOAST_NETWORK_BUSY": "Server busy, please try again later",
            "TOAST_NETWORK_ERROR": "Network connection error, please try again later",
            "TOAST_OPERATE_BUSY": "Too many requests, please try again later",
            "TOAST_PAY_FAILED": "Purchase failed",
            "TOAST_SERVER_BUSY": "Server busy, please try again later",
            "TOAST_SERVER_NOTWORK": "Service unavailable",
            "TOAST_SERVER_TIMEOUT": "Service timeout",
            "TOAST_WRONG_REGION": "This event is not available for your region"
          }
        },
        // {
        //   name: 'हिन्दी',
        //   abbr: 'HI',
        //   tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
        //   pp: 'http://content.garena.com/legal/pp/india_pp_en.html',
        //   transify: {
        //     "TOAST_ERROR_CODE": "Unknown error, error code {code}",
        //     "TOAST_EVENT_CLOSED_AWHILE": "The event is closed temporary",
        //     "TOAST_EVENT_END": "Event ended",
        //     "TOAST_EVENT_NOTOPEN": "Event hasn't started",
        //     "TOAST_GEM_NOT_ENOUGH": "Insufficient diamonds, please top up and come back again",
        //     "TOAST_LOGIN_FAILED": "Login failed",
        //     "TOAST_NETWORK_BUSY": "Server busy, please try again later",
        //     "TOAST_NETWORK_ERROR": "Network connection error, please try again later",
        //     "TOAST_OPERATE_BUSY": "Too many requests, please try again later",
        //     "TOAST_PAY_FAILED": "Purchase failed",
        //     "TOAST_SERVER_BUSY": "Server busy, please try again later",
        //     "TOAST_SERVER_NOTWORK": "Service unavailable",
        //     "TOAST_SERVER_TIMEOUT": "Service timeout",
        //     "TOAST_WRONG_REGION": "This event is not available for your region"
        //   }
        // },
        // {
        //   name: 'မြန်မာဘာသ',
        //   abbr: 'MY',
        //   tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
        //   pp: 'http://ff.garena.com/others/policy/en/',
        //   transify: {
        //     "TOAST_ERROR_CODE": "အမည္မသိခ်ိဳ႕ယြင္းမွဳ, ခ်ိဳ႕ယြင္းမွဳကုဒ္ {code}",
        //     "TOAST_EVENT_CLOSED_AWHILE": "အစီအစဥ္ယာယီပိတ္သည္",
        //     "TOAST_EVENT_END": "အစီအစဥ္ျပီးဆံုးသည္",
        //     "TOAST_EVENT_NOTOPEN": "အစီအစဥ္မစေသးပါ",
        //     "TOAST_GEM_NOT_ENOUGH": "စိန္မလံုေလာက္ပါ, ျဖည့္ျပီးမွ ျပန္လာပါ",
        //     "TOAST_LOGIN_FAILED": "ေလာ့အင္မေအာင္ျမင္ပါ",
        //     "TOAST_NETWORK_BUSY": "ဆာဗာမအားပါ, ေနာက္မွထပ္လုပ္ၾကည့္ပါ",
        //     "TOAST_NETWORK_ERROR": "ဆက္သြယ္မွဳကြန္ယက္ခ်ိဳ႕ယြင္း, ေနာက္မွ\nထပ္ၾကိဳးစားၾကည့္ပါ",
        //     "TOAST_OPERATE_BUSY": "ေတာင္းဆိုမွဳမ်ားေနသည္, ေနာက္မွထပ္လုပ္\nၾကည့္ပါ",
        //     "TOAST_PAY_FAILED": "ဝယ္ယူမွဳမေအာင္ျမင္ပါ",
        //     "TOAST_SERVER_BUSY": "ဆာဗာမအားပါ, ေနာက္မွထပ္ၾကိဳးစားပါ",
        //     "TOAST_SERVER_NOTWORK": "ဝန္ေဆာင္မွဳမရရွိႏိုင္ပါ",
        //     "TOAST_SERVER_TIMEOUT": "ဝန္ေဆာင္မွဳအခ်ိန္ျပည့္",
        //     "TOAST_WRONG_REGION": "သင္၏ေဒသအတြက္ဒီအစီအစဥ္မရရွိႏိုင္ပါ"
        //   }
        // },
        {
          name: 'Malay',
          abbr: 'MS',
          tos: 'http://content.garena.com/legal/tos/india_tos_en.html',
          pp: 'http://content.garena.com/legal/pp/india_pp_en.html',
          transify: {}
        },
        {
          name: 'Hindi',
          abbr: 'HI',
          tos: 'http://content.garena.com/legal/tos/india_tos_en.html',
          pp: 'http://content.garena.com/legal/pp/india_pp_en.html',
          transify: {}
        },
        {
          name: 'German',
          abbr: 'DE',
          tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
          pp: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
          transify: {}
        },
        {
          name: 'Bengali',
          abbr: 'BN',
          tos: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
          pp: 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
          transify: {}
        },
      ],
      indiaLangs: [
        {
          name: 'Malay',
          abbr: 'MS',
          tos: 'http://content.garena.com/legal/tos/india_tos_en.html',
          pp: 'http://content.garena.com/legal/pp/india_pp_en.html',
          transify: {}
        },
        {
          name: 'Hindi',
          abbr: 'HI',
          tos: 'http://content.garena.com/legal/tos/india_tos_en.html',
          pp: 'http://content.garena.com/legal/pp/india_pp_en.html',
          transify: {}
        },
      ],
      items: [],
      login_platform: [],
      toast: {
        show: false,
        isMsg: false,
        text: ''
      },
      loading: { // loading dialog
        show: false,
        opacity: false
      },
      rule: { // rule dialog
        show: false,
        content: ''
      },
      langListOpen: false
    }
  },
  computed: {
    hasConfig() {
      if (this.items.length !== 0 && this.items[0].item_img !== '') {
        return true
      } else {
        return false
      }
    },
    // 当前的语言对象
    selectedLang() {
      return this.is_ind ? this.indiaLangs[this.langIndex] : this.langs[this.langIndex]
    },
    // 当前翻译
    transify() {
      return this.is_ind ? this.indiaLangs[this.langIndex].transify : this.langs[this.langIndex].transify
    }
  },
  methods: {
    addGA(event, msg) { // google 统计
      addGA(event, msg)
    },
    checkGem(price) {
      let flag = true
      if (this.gems < price) {
        flag = false
      }
      return flag
    },
    handleLoading(bool, opacity, delay) { // loading
      if (bool === true) {
        this.loading.opacity = opacity
        this.loading.show = bool
      } else {
        setTimeout(() => {
          this.loading.show = bool
          this.loading.opacity = opacity
        }, delay)
      }
    },
    /**
     * 错误处理
     * @param {String} errCode 错误码
     * @return toast | dialog 组件
     */
    handleError(errCode) {
      this.handleToast(true, errCode, true)
      addGA('msgError', errCode)
    },
    /**
     * 错误处理
     * @param {Boolean} bool 是否显示 toast 组件
     * @param {String} text transify key
     * @param {Boolean} isMsg 是否不可关闭
     * @return toast | dialog 组件
     */
    handleToast(bool, text, isMsg = false) { // toast
      this.toast.show = bool
      this.toast.text = this.transify[text] || this.transify['TOAST_NETWORK_ERROR']
      this.toast.isMsg = isMsg
    },
  }
})



// WEBPACK FOOTER //
// ./src/bus/index.js